/**
 * @file index.tsx
 *
 * @fileoverview Renders multiple columns. Receives an array ReactNodes
 * and displays them in a grid.
 */
import React from "react";
import Grid from "../../../02-atoms/06-layout/04-grid";
import Cell from "../../../02-atoms/06-layout/04-grid/01-cell";
import styles from "./multiColumn.module.scss";

export interface MultiColumnProps {
  /**
   * The intro title for the row, shows above the icons.
   */
  introTitle?: React.ReactNode | string;
  /**
   * The intro text for the row, shows above the icons.
   */
  introText?: React.ReactNode | string;
  /**
   * The list of children that will be displayed as grid.
   */
  items: React.ReactNode[];
}

/**
 * Presents information to a user in a multicolumn way. Useful
 * to show information side by side. Its responsive so no matter how many items
 * are inside it will show as many as possible side by side.
 */
export const MultiColumn = ({
  introTitle,
  introText,
  items,
}: MultiColumnProps) => {
  return (
    <>
      <div className={styles.intro}>
        {introTitle}
        {introText}
      </div>
      <div className={styles.itemsWrapper}>
        <Grid
          columns={"repeat(auto-fit, minmax(200px, 1fr))"}
          justifyItems={["left", "center"]}
        >
          {items &&
            items.map((item, index) => {
              return (
                <Cell key={index} className={styles.itemCell}>
                  {item}
                </Cell>
              );
            })}
        </Grid>
      </div>
    </>
  );
};
